let elements, elementTypes
export const registerElements = (els, elTypes) => {
    //console.log("register", els, elTypes)
    elements = els
    elementTypes = elTypes
}
export const getElements = () => elements
export const getElementTypes = () => elementTypes
